import axios from 'axios';
import { API_BASE_URL , XMARTLAB_API } from '../config';


const api = axios.create({
  baseURL: API_BASE_URL,
});


// Instancia para la API externa
const XmartlabApi = axios.create({
  baseURL: XMARTLAB_API,
  headers: {
    'Content-Type': 'application/json'
  },
});

// Exporta ambas instancias
export { api, XmartlabApi };
export default api;